import { render, staticRenderFns } from "./section-header.vue?vue&type=template&id=60859631&scoped=true&"
import script from "./section-header.vue?vue&type=script&lang=js&"
export * from "./section-header.vue?vue&type=script&lang=js&"
import style0 from "./section-header.vue?vue&type=style&index=0&id=60859631&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60859631",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VListItem } from 'vuetify/lib/components/VList';
import { VListItemAction } from 'vuetify/lib/components/VList';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
installComponents(component, {VBtn,VListItem,VListItemAction,VListItemContent,VListItemTitle})
